import React from 'react'
import styled from 'styled-components'
import FacebookIcon from './common/FacebookIcon'
import InstagramIcon from './common/InstagramIcon'
import TreeForm from './TreeForm'
import { useMediaQuery } from 'react-responsive'
import {Link} from 'gatsby'

const FeatureBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 10px;
  background: white;
  min-height: 200px;
  padding: 20px;
  position: relative;
  padding-bottom: 0;

  .social-section {
    display: flex
  };

  .social {
    margin-bottom: 0 !important;
  }
`

const FeatureBoxElement = (props) => {
    const html = props.html;
    const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1025px)' })

    return(
      <FeatureBox className={isDesktopOrLaptop ? 'overspill' : ''}>
        <div className='columns' style={{flexGrow: '1'}}>
          <div className="column" style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
            <div>
              <h4>{props.heroTitle}</h4>
              <div dangerouslySetInnerHTML={{ __html: html }}></div>
            </div>
            <div className="social-section">
              <FacebookIcon width="35" className='social' />
              <InstagramIcon width="35" className='social' />
          </div>
          </div>
          <div className="column">
            <h4>Help us plant trees!</h4>
            <div>
              Planting trees is one of CAN Borneo's key objectives for rebuilding lost forest and providing for the community.
              You can help us plant more - €1 plants one tree!
            </div>
            <TreeForm />
            <span  style={{justifyContent: 'flex-end', display: 'flex', fontSize: '0.8em' }}><Link to='/donate'>Prefer a general donation?</Link></span>
          </div>
        </div>  
        <div style={{justifyContent: 'space-between', display: 'flex'}}>
        </div>
      </FeatureBox>
    )
}

export default FeatureBoxElement